import { ColumnHelper, RowData } from '@tanstack/react-table';
import { z } from 'zod';

/**
 * Like the official TanStack Table `createColumnHelper`, but it helps with
 * automatically marking a column as sortable. Make sure the `id` property of
 * each column definition actually coincides with the values defined in the
 * provided Zod schema.
 *
 * @param sortableColumnEnumSchema a Zod enum schema that represents the IDs
 * of sortable columns
 */

export function airColumnHelper<TData extends RowData>(
  sortableColumnEnumSchema: z.ZodEnum<[string, ...string[]]>,
): ColumnHelper<TData> {
  const sortableColumns = sortableColumnEnumSchema.options;

  return {
    accessor: (accessor, column) => {
      // Column must be in schema to be sortable, but explicit enableSorting: false overrides
      const isInSchema = sortableColumns.some((x) => x === column.id);
      const enableSorting = column.enableSorting === false ? false : isInSchema;

      return typeof accessor === 'function'
        ? ({
            ...column,
            enableSorting,
            enableMultiSort: enableSorting,
            accessorFn: accessor,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
          } as any)
        : {
            ...column,
            enableSorting,
            enableMultiSort: enableSorting,
            accessorKey: accessor,
          };
    },
    display: (column) => column,
    group: (column) => column,
  };
}
